<template>
  <div>
    <DocumentHeader header="หน้าใบส่งคืนสินค้า (รอการอัพเดท)" link_back="stock/document/returnproductreceipt"/>
    <Document_details_complete/>
  </div>
</template>

<script>
import DocumentHeader from "@/components/admin/document_stock/header_document/DocumentHeader";
import Document_details_complete from "@/components/admin/document_stock/Document_details_complete";
export default {
  name: "DocumentDetailsComplete",
  components: {
    Document_details_complete,
    DocumentHeader
  }
}
</script>

<style scoped>

</style>
